export enum GaugeType {
  CRITICAL,
  WARNING,
  HEALTHY,
  OFFLINE
}

export interface GaugeData {
  count:        number;
  percentage:   number;
  type:         GaugeType;
}

export interface DeviceMetrics {
  gauges: GaugeData[];
}
